import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const SwotCard = ({ model }) => {
    const navigate = useNavigate();
    const { swot } = model;
    const total = swot.strengths + swot.weaknesses + swot.opportunities + swot.threats;

    if (total === 0) {
        return (
            <OverviewCardShell
                title="SWOT"
                compact
                footer={<OverviewTextAction onClick={() => navigate('/swot')}>Open SWOT →</OverviewTextAction>}>
                <p className={styles.cardDescription}>Not started — develops as project findings are captured.</p>
            </OverviewCardShell>
        );
    }

    return (
        <OverviewCardShell
            title="SWOT"
            compact
            headerAside={swot.updatedLabel ? <span className={styles.cardMutedSmall}>{swot.updatedLabel}</span> : null}
            footer={<OverviewTextAction onClick={() => navigate('/swot')}>Open SWOT →</OverviewTextAction>}>
            <p className={styles.cardStatus}>{total} items</p>
            <div className={styles.swotGrid}>
                <div>
                    <span className={styles.swotCountPositive}>{swot.strengths}</span>
                    <span className={styles.swotLabel}>Strengths</span>
                </div>
                <div>
                    <span className={styles.swotCountNegative}>{swot.weaknesses}</span>
                    <span className={styles.swotLabel}>Weaknesses</span>
                </div>
                <div>
                    <span className={styles.swotCountPositive}>{swot.opportunities}</span>
                    <span className={styles.swotLabel}>Opportunities</span>
                </div>
                <div>
                    <span className={styles.swotCountNegative}>{swot.threats}</span>
                    <span className={styles.swotLabel}>Threats</span>
                </div>
            </div>
        </OverviewCardShell>
    );
};

export default SwotCard;
